import React, { useState, useEffect } from 'react';
import { Input, Select, Table, Modal } from 'antd';
import SessionManager from '../routes/SessionManager';
import no_image from '../assets/img/no-image.png';
import $ from 'jquery';
import Loading from '../components/Loading';
import Toastr from 'toastr';
import PermissionModal from '../components/modals/PermissionModal';
import UserModal from '../components/modals/UserModal';
import { SearchOutlined } from '@ant-design/icons';
import CommonUtils from '../util/CommonUtils';

const { Option } = Select;
let searchInput;

function AdminConsole() {

    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    let customer_id = user.customer_id;

    const [customer_users, setCustomerUsers] = useState([]);
    const [customer_sites, setCustomerSites] = useState([]);
    const [user_selected, setUserSelected] = useState({ username: "", sites: [] });
    const [zones, setZones] = useState([]);
    const [site_id, setSiteId] = useState(null);
    const [access_type, setAccessType] = useState('ZONE');
    const [access_group, setAccessGroup] = useState(null);
    const [toggleUser, setToggleUser] = useState(false);
    const [role_map, setRoleMap] = useState([]);
    const [loading, setLoading] = useState(true);
    const [site_spec_users, setSiteSpecUsers] = useState(null);
    const [roles, setRoles] = useState({});
    const [access_groups, setAccessGroups] = useState(null);
    const [access_group_users, setAccessGroupUsers] = useState([]);

    let role_color = { 1: "#FFC107", 2: "#90EE90", 3: "#5F9EA0", 4: "#FF7F50" };

    useEffect(() => {
        fetchSiteSpecUsers();
    }, [customer_users]);

    useEffect(() => {
        if (site_id !== null)
            fetchSiteLocationZones();
    }, [site_id]);

    useEffect(() => {
        fetchCustomerUsers()
        fetchCustomerSites();
        fetchAccessGroups();
        fetchSiteSuptUIRoles();
    }, []);

    const fetchSiteSuptUIRoles = () => {
        let data = {
            "source": "D",
            "criteria": { "from": 0, "size": 1000, "dom_id": "SITESUPT-UI-ROLE" },
            "user_login": user.user_login,
            "user_token": user.user_token,
            "user_type": "user"
        };

        $.ajax({
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom/fetch',
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then((res) => {
            if (res.status && res.status.code === 200) {
                let roles_map = [];
                let roles = {};
                let allowedRoles = ["1", "2", "3", "4"];
                for (let role of res.data.records) {
                    if (allowedRoles.indexOf(role.dom_key) > -1) {
                        roles_map.push({ label: role.dom_val, value: role.dom_key });
                        roles[role.dom_key] = role.dom_val;
                    }
                }
                setRoleMap(roles_map);
                setRoles(roles);
            } else {
                setRoleMap([]);
                setRoles({});
            }
        });
    }

    const fetchCustomerUsers = () => {
        setLoading(true);
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            criteria: {
                from: 0,
                size: 1000,
                customer_id: user.customer_id
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/user/fetch',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let customer_users = [];
                    for (let r of res.data.records) {
                        if (r.record && r.record.user_state === "Inactive") {
                            continue
                        }
                        customer_users.push(r.record);
                    }
                    setCustomerUsers(customer_users);
                } else {
                    Toastr.error('Error');
                }
            }
        )
    }

    const fetchCustomerSites = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            criteria: {
                from: 0,
                size: 1000,
                customer_id: user.customer_id
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/site/fetch',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let customer_sites = [];
                    for (let r of res.data.records) {
                        customer_sites.push(r.record);
                    }
                    setCustomerSites(customer_sites);
                } else {
                    Toastr.error('Error');
                }
            }
        )
    }

    const onUserChange = (user_selected) => {
        let user = customer_users.filter(u => u.user_login === user_selected.value);
        setUserSelected(user[0]);
        setSiteId(null);
    }

    const onSiteChange = (site_id) => {
        console.log(site_id)
        setSiteId(site_id);
    }

    const saveSiteAccess = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: {
                user_login: user_selected.user_login,
                user_zones: user_selected.user_zones
            }
        }
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/user/modify',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let customerusers = customer_users;
                    if (user.user_login === user_selected.user_login) {
                        var user1 = sessionMgr.readCookie("user");
                        user1.user_zones = user_selected.user_zones;
                        sessionMgr.storeCookie("user", user1);
                    }
                    setCustomerUsers(customerusers);
                    Toastr.success('Saved Successfully !');
                } else {
                    Toastr.error('Error occured ... Please try again !')
                }
            }
        )
    }

    const saveGroupAccess = (user, selected) => {

        if (!access_group) {
            Toastr.error('Please select an access group');
            return;
        }

        let accesstype = access_type + '';
        let accessgroup = access_group + '';

        //console.log('access: ', [access_type, access_group]);
        //console.log('user: ', JSON.stringify(user.access_groups));

        if (Array.isArray(user.access_groups)) {
            user.access_groups = {};
        }

        if (user.access_groups) {
            if (user.access_groups[accesstype] !== undefined) {
                let access_groups = [];
                let found = false;
                for (let g of user.access_groups[accesstype]) {
                    if (g === access_group)
                        found = true;
                    else
                        access_groups.push(g);
                }

                if (!found)
                    access_groups.push(access_group);

                user.access_groups[accesstype] = access_groups;
            } else {
                user.access_groups[accesstype] = [accessgroup]
            }
        } else {
            user.access_groups = { [accesstype]: [accessgroup] };
        }

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: {
                user_login: user.user_login,
                access_groups: user.access_groups
            }
        }
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/user/modify',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let customerusers = [...customer_users];
                    for (let u of customerusers) {
                        if (u.user_login === user.user_login) {
                            u.access_groups = user.access_groups;
                        }
                    }
                    setCustomerUsers(customerusers);
                    Toastr.success('Saved Successfully !');
                } else {
                    Toastr.error('Error occured ... Please try again !')
                }
            }
        )
    }

    const toggleSelection = (val) => {
        let siteid = (site_id) + '';
        var user_zones_obj = user_selected.user_zones;

        if (user_zones_obj) {
            if (Object.keys(user_zones_obj).indexOf(siteid) !== -1) {
                if (user_zones_obj[siteid].indexOf(val) !== -1) {
                    let finalZones = [];
                    for (let z of user_zones_obj[siteid]) {
                        if (z !== val)
                            finalZones.push(z);
                    }
                    user_zones_obj[siteid] = finalZones;
                } else {
                    user_zones_obj[siteid].push(val);
                }
            } else {
                user_zones_obj[siteid] = [val];
            }
        } else {
            user_zones_obj = {};
            user_zones_obj[siteid] = [val];
        }

        let userselected = JSON.parse(JSON.stringify(user_selected));
        userselected.user_zones = user_zones_obj;
        setUserSelected(userselected)
    }

    const getClassName = (val) => {
        let zoneClassName = "far fa-lg text-primary fa-square";
        if (val) {
            var user_zones = user_selected.user_zones;
            if (user_zones && user_zones[site_id] && user_zones[site_id].indexOf(val) !== -1) {
                zoneClassName = "fa fa-lg text-primary fa-check-square";
            }
        }
        return zoneClassName;
    }

    const fetchSiteLocationZones = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: site_id,
            user_login: user.user_login,
            user_token: user.user_token
        };
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    setZones(res.data);
                }
            })
    };

    const fetchAccessGroups = () => {
        let data = {
            "source": "D",
            "criteria": { "from": 0, "size": 1000, "dom_id": "SITESUPT-UI-ACCESS-GROUP-" + access_type + "-" + customer_id },
            "user_login": user.user_login,
            "user_token": user.user_token,
            "user_type": "user"
        };

        $.ajax({
            url: `https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom/fetch`,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then(
            res => {
                if (res.status && res.status.code === 200) {
                    if (res.data && res.data.records.length > 0) {
                        setAccessGroups(res.data.records);
                    } else {
                        setAccessGroups([]);

                        return null;
                    }
                } else {
                    setAccessGroups([]);
                }
            },
            res => {
            }
        );
    }

    const onAccessTypeChange = (obj) => {
        setAccessType(obj);
        setAccessGroup(null);
        setAccessGroups([]);
        fetchAccessGroups();
    }

    const onAccessGroupChange = (obj) => {
        setAccessGroup(obj);

    }

    const onCheckboxChange = (v) => {
        setAccessGroupUsers(v)
    }

    const toggleEditUser = () => {
        setToggleUser(!toggleUser);
    }

    const handleClose = () => {
        setToggleUser(!toggleUser);
    }

    var getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                {dataIndex !== "user_role" ?
                    <Input
                        ref={node => {
                            searchInput = node
                        }}
                        placeholder={`Search`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    /> : <React.Fragment>
                        <Select
                            style={{ width: '250px', fontSize: '13px' }}
                            className={"font-size-13 text-left mb-3"}
                            placeholder={"Choose Role"}
                            options={role_map}
                            onChange={(selected) => handleSearch(selected, confirm, dataIndex, true)} >
                        </Select>
                        <br />
                    </React.Fragment>
                }
                <button
                    className="btn btn-sm btn-primary handle-reset"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </button>
                <button
                    className="btn btn-sm btn-light"
                    onClick={() => handleReset(clearFilters)}
                    style={{ width: 90 }}
                >
                    Reset
                </button>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => {
            return (record[dataIndex] && record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()));
        },
        onFilterDropdownVisibleChange: visible => {
            if (visible && dataIndex !== "user_role") {
                setTimeout(() => searchInput.select(), 100);
            }
        }
    })

    let user_columns = [
        {
            title: "Name",
            dataIndex: 'user_name',
            render: (user_name) => <span className="font-size-12 text-primary">{user_name}</span>,
            ...getColumnSearchProps('user_name'),
            width: 'auto',
            sortDirections: ["ascend", "descend", "ascend"],
        },
        {
            title: "Login ID",
            dataIndex: 'user_login',
            render: (user_login) => <span className="font-size-12 text-primary">{user_login}</span>,
            ...getColumnSearchProps('user_login'),
            width: 'auto',
            sortDirections: ["ascend", "descend", "ascend"]
        },
        {
            title: "Role",
            dataIndex: 'user_role',
            render: (user_role) => {
                return <span className="badge badge-default font-size-13 text-dark" style={{ background: roles && role_color[user_role] }}>{(roles && role_color) && roles[user_role]}</span>;
            },
            ...getColumnSearchProps('user_role', (user_role) => { return roles && roles[user_role]; }),
            width: 'auto',
            sortDirections: ["ascend", "descend", "ascend"]
        },
        {
            title: "Phone",
            dataIndex: 'user_phone1',
            render: (user_phone1) => <span className="font-size-12 text-primary">{user_phone1}</span>,
            width: 'auto',
            sortDirections: ["ascend", "descend", "ascend"]
        },
        {
            title: "Modified By",
            dataIndex: 'modified_by',
            render: (modified_by) => {
                return <span className="text text-primary font-size-13">{modified_by || 'SYSTEM'}</span>
            },
            width: 'auto',
            sortDirections: ["ascend", "descend", "ascend"]
        }
    ]

    const handleSearch = (selectedKeys, confirm, dataIndex, roles) => {
        confirm();
        if (roles) {
            let sitesupt_users = [...customer_users];
            let site_spec_users = sitesupt_users.filter((record) => Number(record.user_role) === Number(selectedKeys[0]) && record.user_sites.includes(user.site_selected.site_id));
            let role_specific_users = site_spec_users.filter((r) => Number(r.user_role) === Number(selectedKeys[0]));
            // this.setState({ site_spec_users: role_specific_users });
            setSiteSpecUsers(role_specific_users);
        }
    }

    const handleReset = (clearFilters) => {
        clearFilters();
        let sitesupt_users = [...customer_users];
        let site_spec_users = sitesupt_users.filter((record) => record.user_role <= "4" && record.user_sites.includes(user.site_selected.site_id));
        // this.setState({ searchText: '', site_spec_users });
        setSiteSpecUsers(site_spec_users);
        $('.handle-reset').trigger('click')
    }

    const fetchSiteSpecUsers = () => {
        let sitesupt_users = [...customer_users];
        let site_spec_users = sitesupt_users.filter((record) => record.user_role <= "4" && record.user_sites.includes(user.site_selected.site_id));
        setSiteSpecUsers(site_spec_users);
    }

    useEffect(() => {
        if (site_spec_users && site_spec_users.length > 0) {
            setLoading(false);
        }
    }, [site_spec_users]);

    let user_sites = user_selected ? user_selected.user_sites : [];
    let allowed_sites = user_sites && user_sites.length > 0 ? customer_sites.filter(s => user_sites.indexOf(s.site_id + '') !== -1) : [];

    let accessgroupusers = [];
    if (access_type && access_group) {
        for (let u of customer_users) {
            if (u.access_groups && u.access_groups) {
                //console.log('user> ', u.access_groups);
            }
            if (u.access_groups && u.access_groups[access_type] && u.access_groups[access_type].indexOf(access_group) !== -1) {
                accessgroupusers.push(u.user_login);
            }
        }
    }

    return (
        <React.Fragment>
            <div className="page-container">
                <div className="row">
                    <div className="col-lg-12 px-0">
                        <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link p-1 px-3 active" id="admin-console-tab" data-toggle="tab" href="#admin-console" role="tab">
                                    Admin Console
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link p-1 px-3" id="access-groups-tab" data-toggle="tab" href="#access-groups" role="tab">
                                    User Access Groups
                                </a>
                            </li>
                            {CommonUtils.hasPermission('SITESUPT-UI-CREATE-USER') && <li className="nav-item">
                                <a className="nav-link p-1 px-3" id="user-tab" data-toggle="tab" href="#user" role="tab">
                                    Create User
                                </a>
                            </li>}
                        </ul>
                        <div className="tab-content bg-white py-4 px-md-5 px-2" id="myTabContent" style={{ minHeight: "300px" }}>
                            <div className="tab-pane fade show active" id="admin-console" role="tabpanel" aria-labelledby="admin-console-tab">

                                <div className="row">
                                    <div className="col-md-12">
                                        <span className="text-app font-size-11">To give permission to access the zones for specific user.</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <Select showSearch labelInValue className="mr-1" style={{ width: 200 }} onSelect={onUserChange} placeholder="Select User">
                                            {customer_users && customer_users.map((user, i) => <Option key={i} value={user.user_login}> {user.user_name} - {user.user_login}</Option>)}
                                        </Select>
                                    </div>
                                    <div className="col-md-3">
                                        <Select value={site_id} className="mr-1" style={{ width: 200 }} onSelect={(a) => onSiteChange(a)} placeholder="Select Site">
                                            {allowed_sites.map((site, i) => <Option key={i} value={site.site_id} > {site.site_name} </Option>)}
                                        </Select>
                                    </div>
                                    {user_selected && site_id &&
                                        <div className="col-md-6 pl-2">
                                            <span className="pull-right">
                                                <button className="btn btn-sm w-75 btn-primary ml-2" onClick={saveSiteAccess} >Save</button>
                                            </span>
                                        </div>
                                    }
                                </div>
                                {user_selected && site_id &&
                                    <React.Fragment>
                                        <div className="card border border-0 bg-light mt-4">
                                            <div className='card-header p-0'>
                                                <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                                                    Select Zones
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body bg-white border-light">
                                            <div className="row">
                                                {
                                                    zones.length === 0 && <div className="col-md-5"><Loading> Loading ... </Loading></div>
                                                }
                                                {
                                                    zones.map((z, k) =>
                                                        <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2" key={k}>
                                                            <img onError={(e) => e.target.src = no_image} className="img-fluid border-light border-rounded-t cursor-pointer" src={z.image} alt={z.location_name} onClick={(e) => toggleSelection(z.location_id)} />
                                                            <div role="group" className="bg-light py-1 border-rounded-b" onClick={(e) => toggleSelection(z.location_id)}>
                                                                <span className="p-2"><i className={getClassName(z.location_id)}></i></span>
                                                                <span className="mt-2 font-size-12"><span data-toggle="tooltip" data-placement="bottom" title={z.location_name.length > 12 ? z.location_name : ''}>{z.location_name.length > 12 ? z.location_name.substring(0, 12) + '..' : z.location_name}</span></span>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </React.Fragment>
                                }

                            </div>

                            <div className="tab-pane fade" id="access-groups" role="tabpanel" aria-labelledby="access-groups-tab">
                                <div className="row">
                                    <div className="col-md-12 text-right">
                                        <PermissionModal obj={this} title={"Add"}></PermissionModal>
                                    </div>
                                </div>
                                <div className="row pb-4">
                                    <div className="col-md-3">
                                        <label>Access Type:</label><br />
                                        <Select
                                            value={access_type || ''}
                                            onChange={onAccessTypeChange}
                                            options={[{ dom_key: 'ROLE', dom_val: 'User Access' }, { dom_key: 'ZONE', dom_val: 'Zone Access' }].map((a) => { return { value: a.dom_key, label: a.dom_val }; })}
                                            style={{ width: '200px' }}
                                            placeholder="Choose Access Type" />
                                    </div>

                                    <div className="col-md-5">
                                        <label>Access Group:</label><br />
                                        <Select
                                            value={access_group || ''}
                                            loading={access_groups == null}
                                            onChange={onAccessGroupChange}
                                            options={access_groups ? access_groups.map((a) => { return { value: a.dom_key, label: a.dom_val }; }) : []}
                                            style={{ width: '100%' }}
                                            placeholder={!access_groups ? "Fetching access groups" : access_groups.length > 0 ? "Choose Access Group" : "No Access Groups found ..."} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {access_group && customer_users
                                            &&
                                            <Table pagination={false} style={{ width: '100%' }}
                                                rowSelection={{
                                                    hideSelectAll: true, selectionType: 'checkbox', selectedRowKeys: access_group_users,
                                                    onChange: (v) => onCheckboxChange(v),
                                                    onSelect: (a, b, c) => saveGroupAccess(a, b, c)
                                                }} rowKey={"user_login"} columns={[{
                                                    title: 'User',
                                                    dataIndex: 'user_login',
                                                    key: 'user_login',
                                                }]} dataSource={customer_users || []}></Table>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="user" role="tabpanel" aria-labelledby="user-tab">
                                <span className='pull-right'>
                                    <button className="btn btn-sm btn-primary" onClick={() => toggleEditUser(null)}>
                                        + Create New
                                    </button>
                                </span>
                                <br />
                                <div className='row mt-3'>
                                    <div className="col-md-12">
                                        <Table
                                            className="table-app table-hover"
                                            loading={loading}
                                            showSorterTooltip={false}
                                            columns={user_columns}
                                            rowKey={record => record.user_login}
                                            dataSource={site_spec_users}
                                            pagination={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            {
                                toggleUser &&
                                <Modal
                                    maskClosable={false}
                                    bodyStyle={{ padding: "0px 0px 0px 5px" }}
                                    footer={false}
                                    className="modal-md"
                                    closable={true}
                                    open={toggleUser}
                                    title='Create user for current site'
                                    // destroyOnClose={true}
                                    closeIcon={<div style={{ marginTop: "-5px" }}><i className="fa fa-lg fa-times-circle pb-3 text-white" onClick={() => setToggleUser(false)}></i></div>}
                                >
                                    <UserModal updateUser={fetchCustomerUsers} toggleEditUser={handleClose} />
                                </Modal>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </React.Fragment >
    )
}

export default AdminConsole;